import '@mdi/font/css/materialdesignicons.css';
import LuxonAdapter from '@date-io/luxon';
import { type ThemeDefinition, createVuetify as _createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import { ru } from 'vuetify/locale';

class MyAdapter extends LuxonAdapter {
  getWeekdays = () => ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС'];
}

const fundayTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#fff',
    'on-background': '#333',
    surface: '#fff',
    'on-surface': '#333',
    'surface-variant': '#1a82cb',
    'on-surface-variant': '#fff',
    'surface-light': '#95d4e9',
    'surface-bright': '#95d4e9',
    primary: '#1a82cb',
    'on-primary': '#fff',
    secondary: '#95d4e9',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
  },
  variables: {
    'high-emphasis-opacity': 0.5,
  },
};

export function createVuetify() {
  return _createVuetify({
    ssr: true,
    theme: {
      defaultTheme: 'fundayTheme',
      themes: {
        fundayTheme,
      },
    },
    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      },
    },
    locale: {
      locale: 'ru',
      messages: { ru },
    },
    date: {
      adapter: new MyAdapter({ locale: 'ru' }),
    },
  });
}
